import React from 'react';
import {Theme, ThemeName, Icon, InfoIcon} from '@taopix/taopix-design-system';

type PaletteInformationMessagePropTypes = {
  message?: string;
};

const PaletteInformationMessage = ({message}: PaletteInformationMessagePropTypes) => {
  return (
    <Theme name={ThemeName.Information} className={'flex px-sm py-xs sm:mx-auto'}>
      <Icon icon={<InfoIcon />} />
      <span
        data-testid={'box-settings-palette-not-available-message'}
        className={'flex items-center ml-sm'}
      >
        {message}
      </span>
    </Theme>
  );
};

export default PaletteInformationMessage;
